import { render, staticRenderFns } from "./GoogleLoginBtn.vue?vue&type=template&id=7b3a3c40&"
import script from "./GoogleLoginBtn.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginBtn.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLoginBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports